import { Trans } from '@lingui/react/macro';
import { createFileRoute, Link } from '@tanstack/react-router';
import { z } from 'zod';
import { CenteredShell, Eyebrow, Headline } from '../components/auth-shells.js';
import { Mag } from '../components/mag.js';

const searchSchema = z.object({
  email: z.string().optional(),
});

export const Route = createFileRoute('/forgot-password/sent')({
  validateSearch: searchSchema,
  component: ForgotPasswordSentPage,
});

// Handoff §15.2 — centered shell. Transactional surface: link is on its way.
function ForgotPasswordSentPage() {
  const { email } = Route.useSearch();
  return (
    <CenteredShell>
      <Mag size={120} />
      <Eyebrow>
        <Trans>check your inbox</Trans>
      </Eyebrow>
      <Headline>
        <Trans>link's on its way.</Trans>
      </Headline>
      <p className="font-serif text-xl leading-tight text-[var(--ink)]/80">
        <Trans>“tap the button in the email — i'll let you set a new one.”</Trans>
      </p>
      {email ? (
        <p className="text-[14px] text-[var(--ink)]/70">
          <Trans>
            sent to <span className="font-mono">{email}</span>
          </Trans>
        </p>
      ) : null}
      <div className="mt-4 flex flex-col items-center gap-2">
        <Link to="/forgot-password" search={email ? { email } : {}} className="link-plum">
          <Trans>send it again</Trans>
        </Link>
        <Link to="/login" className="link-quiet">
          <Trans>back to sign in</Trans>
        </Link>
      </div>
    </CenteredShell>
  );
}
